import * as React from 'react';

import Mentions from 'antd/es/mentions';

import { ChatPlugin } from '@common/react/components/Chat/Chat';

export const MentionPlugin: ChatPlugin = {
	formComponent: (props) => <Mentions
		{...props}
	/>,
};
